import { useEffect, useRef, useState } from "react";

const Sections2 = ({ data, path }) => {
    const [currentItem, setCurrentItem] = useState(0);
    const [startX, setStartX] = useState(0);
    const [isTouching, setIsTouching] = useState(false);
    const containerRef = useRef();
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
        if (containerRef.current) {
            setContainerWidth(containerRef.current.clientWidth);
        }
        const handleResize = () => {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.clientWidth);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleTouchStart = (e) => {
        setStartX(e.touches[0].clientX);
        setIsTouching(true);

    };

    const handleTouchMove = (e) => {
        if (!isTouching) return;
        const currentX = e.touches[0].clientX;
        const diffX = startX - currentX;

        // Update the transform for the swipe effect
        if (diffX > 50) {
            if (currentItem < data.services.list.length - 1) {
                setCurrentItem(prev => prev + 1)
            }  // Stop the swipe
            setIsTouching(false);

        } else if (diffX < -50) {
            if (currentItem > 0) {
                setCurrentItem(prev => prev - 1)
            }
            setIsTouching(false);  // Stop the swipe

        }
    };

    const handlChange = (index) => {
        setCurrentItem(index);
    };

    useEffect(() => {
        setCurrentItem(0);

    }, [path])

    return (
        <div className={`2xl:container bg-greybg sm:bg-white  mx-auto flex flex-col w-full py-[72px] md:py-20  px-6  md:px-10 lg:px-20 `}>
            <h2 className="font-semibold text-24 md:text-36 lg:text-42 text-primarycolor px-6 text-center w-full md:px-10 lg:px-20 ">
                {data.services.title}
            </h2>

            <div className="grid grid-cols-1 pt-16 md:grid-cols-4 lg:grid-cols-6 gap-4">
                {data.services.list.map((item, i) => {
                    const totalItems = data.services.list.length;
                    const itemsPerRowMD = 2;
                    const itemsPerRowLG = 3;

                    const isLastRowMD = totalItems % itemsPerRowMD !== 0 && i >= totalItems - (totalItems % itemsPerRowMD);
                    const isLastRowLG = totalItems % itemsPerRowLG !== 0 && i >= totalItems - (totalItems % itemsPerRowLG);

                    // Default span for full row
                    let spanClass = "md:col-span-2 lg:col-span-2";

                    // If 2 items in last row
                    if (isLastRowMD && totalItems % itemsPerRowMD === 2) {
                        spanClass = "md:col-span-2"; // 2 items evenly split at md
                    } else if (isLastRowMD && totalItems % itemsPerRowMD === 1) {
                        spanClass = "md:col-span-4"; // full span at md
                    }

                    if (isLastRowLG && totalItems % itemsPerRowLG === 2) {
                        spanClass += " lg:col-span-3"; // half at lg
                    } else if (isLastRowLG && totalItems % itemsPerRowLG === 1) {
                        spanClass += " lg:col-span-6"; // full span at lg
                    }

                    return (
                        <>
                            <div key={i} className={`flex bg-white flex-col w-full rounded-[16px] gap-6 p-6 border-journyborder border-[1px] shadow-services ${spanClass}`}>
                                <div className="flex gap-3 items-center">
                                    <img src={process.env.PUBLIC_URL + item.icon} alt="icon" />
                                    <h4 className="font-medium text-18 sm:text-20 text-primarycolor">{item.heading}</h4>
                                </div>
                                <p className="text-seondaryblack font-regular text-14 sm:text-16">{item.desc}</p>
                            </div>
                        </>
                    );
                })}
            </div>




            {/* MARK:Old-Design */}

            {/* <div className="relative w-full overflow-hidden">
                <div className={`flex gap-6 pt-16 pb-8 transition-transform duration-1000 ${data.services.list.length <= 3 && window.innerWidth > 1000 ? "justify-center" : ""}`}
                    style={{ transform: `translateX(-${(window.innerWidth < 1200 ? window.innerWidth < 920 ? currentItem : currentItem * 2 : currentItem * 3) * (containerWidth + 26)}px)` }}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                >
                    {data.services.list.map((item, i) => (
                        <div ref={containerRef} key={i}
                            className="flex bg-white flex-col min-w-full md:min-w-[400px] md:max-w-[400px] rounded-[16px] gap-6 p-6 border-journyborder border-[1px] shadow-services">
                            <div className="flex gap-3 items-center">
                                <img src={process.env.PUBLIC_URL + item.icon} alt="icon" />
                                <p className="font-medium text-18 sm:text-20 text-primarycolor">{item.heading}</p>
                            </div>
                            <p className="text-seondaryblack font-regular text-14 sm:text-16">{item.desc}</p>
                        </div>
                    ))}

                </div>
            </div> */}

            {/* {((window.innerWidth<1000 && data.services.list.length!==1) || (data.services.list.length>3 )) ? (<div className="flex justify-center items-center gap-1">
                {Array.from({ length: Math.ceil(window.innerWidth<1200 ?window.innerWidth<920?data.services.list.length: data.services.list.length/2:data.services.list.length/3) }).map((_, i) => (
                    <div
                        key={i}
                        className={`rounded-full cursor-pointer border-black ${currentItem === i
                            ? "bg-ctaorange h-[10px] w-[20px]"
                            : "bg-[rgba(0,0,0,0.2)] h-[10px] w-[10px]"
                        }`}
                        onClick={() => handlChange(i)}
                    ></div>
                ))}
            </div>):<></>} */}
            {/* MARK:Old-Design */}

        </div>
    );
}
export default Sections2;



